export default "__VITE_ASSET__DszlkvN$__"